export default {"src":"/_next/static/media/telegram-white.693a9ab0.svg","height":12,"width":12};